import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Core } from "@faire/design-tokens";
import { Button } from "@faire/web--source/slate/Button";
import { Row } from "@faire/web--source/slate/Layout";
import { LoadingSpinner } from "@faire/web--source/slate/LoadingSpinner";
import { Modal } from "@faire/web--source/slate/Modal";
import { getSpacing } from "@faire/web--source/slate/spacing";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import { trackRetailersFilterInteraction } from "@faire/web-api--source/events/retailers/actionUnknown/filterInteraction";
import React from "react";
import styled from "styled-components";
import { FilterBar } from "../FilterBar";
import { useFilterStore } from "../useFilterStore";
export var FilterModal = function(param) {
    var name = param.name, resultsCount = param.resultsCount, isLoading = param.isLoading, children = param.children;
    var _useFilterStore = useFilterStore([
        "isSideBarVisible",
        "isMobileModalOpen",
        "isNewFilterSelected"
    ]), _useFilterStore_data = _useFilterStore.data, isMobileModalOpen = _useFilterStore_data.isMobileModalOpen, isNewFilterSelected = _useFilterStore_data.isNewFilterSelected, setFilterState = _useFilterStore.setFilterState;
    var handleModalClose = function() {
        trackRetailersFilterInteraction(name, "close_filters", "modal");
        setFilterState(function(currentState) {
            return _object_spread_props(_object_spread({}, currentState), {
                isMobileModalOpen: false,
                isNewFilterSelected: false
            });
        });
    };
    return /*#__PURE__*/ _jsxs(Modal, {
        isOpen: isMobileModalOpen,
        showCloseButton: true,
        onClose: handleModalClose,
        "data-test-id": "".concat(name, "-filter-modal"),
        padding: getSpacing("7x", 12),
        children: [
            /*#__PURE__*/ _jsx(FilterBar, {
                name: name,
                isModal: true,
                children: children
            }),
            /*#__PURE__*/ _jsx(MobileButtonsRow, {
                children: /*#__PURE__*/ _jsx(MobileButton, {
                    onClick: handleModalClose,
                    children: isLoading || isNewFilterSelected ? /*#__PURE__*/ _jsx(LoadingSpinner, {
                        color: Core.icon.inverse,
                        size: "small"
                    }) : /*#__PURE__*/ _jsx(StrictLocalMsg, {
                        id: "yU/bMW",
                        defaultMessage: [
                            {
                                type: 0,
                                value: "Show "
                            },
                            {
                                type: 1,
                                value: "resultsCountNumber"
                            },
                            {
                                type: 0,
                                value: " matches"
                            }
                        ],
                        values: {
                            resultsCountNumber: resultsCount
                        }
                    })
                })
            })
        ]
    });
};
var MobileButtonsRow = styled(Row).withConfig({
    componentId: "sc-ef22dbf-0"
})([
    "position:absolute;width:100%;bottom:0;background:white;padding:",
    ";border-top:1px solid ",
    ";z-index:11;"
], getSpacing("2x"), Core.border.muted);
var MobileButton = styled(Button).withConfig({
    componentId: "sc-ef22dbf-1"
})([
    "width:100%;"
]);
